export enum enumPaymentState {
  CREATED,
  CONFIRMED,
  NOT_VALIDATED,
  PENDING,
  CANCELED,
  FAILED,
  SUCCESS,
  MULTI_FAILED,
  DELAYED,
  EXECUTE_PENDING,
  OUTDATED,
  ITEMS_PENDING = 11,
  REFUNDED = 12,
  PARTIALLY_REFUNDED = 13,
}
